import { useState, type FormEvent } from 'react';
import { Button } from '../common/Button.js';

interface FreeTextInputProps {
  onSubmit(text: string): void;
  disabled?: boolean;
}

export function FreeTextInput({ onSubmit, disabled }: FreeTextInputProps): JSX.Element {
  const [text, setText] = useState('');

  function submit(e: FormEvent) {
    e.preventDefault();
    const v = text.trim();
    if (!v) return;
    onSubmit(v);
    setText('');
  }

  return (
    <form onSubmit={submit} className="mt-2 flex w-full gap-2">
      <input
        type="text"
        value={text}
        onChange={e => setText(e.target.value)}
        disabled={disabled}
        placeholder="...or describe in your own words"
        className="flex-1 rounded-md border border-bark-300 bg-paper-50 px-3 py-2 font-body text-sm text-ink-900 placeholder:text-bark-500 focus:border-sage-700 focus:outline-none focus:ring-2 focus:ring-sage-300"
      />
      <Button type="submit" variant="secondary" size="sm" disabled={disabled || !text.trim()}>
        Send
      </Button>
    </form>
  );
}
